module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b90566cbf96f1c45ab29b17c1264056b.png";